<template>
  <el-form ref="searchForm" :model="searchForm" class="search-form">
    <div v-for="(item, index) in searchList" :key="index">
      <!--    输入框-->
      <el-form-item v-if="item.type === 'input'" class="form-item" :prop="item.id" :label="item.text">
        <el-input class="input" v-model="searchForm[item.id]" :maxlength="item.maxlength || 200"
          :placeholder="item.placeholder" />
      </el-form-item>
      <el-form-item v-if="item.type === 'inputId'" class="form-item" :prop="item.id" :label="item.text">
        <el-input class="input" type="number" v-model="searchForm[item.id]" :placeholder="item.placeholder" />
      </el-form-item>
      <!--    选择输入框-->
      <el-form-item v-if="item.type === 'select'" class="form-item" :prop="item.id" :label="item.text">
        <template v-if="item.id === 'promoteCode'">
          <el-select v-model="searchForm[item.id]" :placeholder="item.placeholder">
            <el-option v-for="item in promoteList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select></template>
        <template v-else-if="item.id === 'status'">
          <el-select v-model="searchForm[item.id]" clearable :placeholder="item.placeholder">
            <el-option v-for="item in optionsStatus" :key="item.value" :label="item.label" :value="item.value" />
          </el-select></template>
        <template v-else-if="item.id === 'couponTypeId'">
          <el-select v-model="searchForm[item.id]" clearable :placeholder="item.placeholder">
            <el-option v-for="item in optionsTypeCoupon" :key="item.value" :label="item.label" :value="item.value" />
          </el-select></template>
        <template v-else>
          <el-select v-model="searchForm[item.id]" :placeholder="item.placeholder">
            <el-option v-for="item in item.optionsType || optionsType" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </el-form-item>
      <!--        时间选择框-->
      <el-form-item :prop="item.id" :label="item.text" v-if="item.type === 'time'" style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" type="daterange" range-separator="-" start-placeholder="年/月/日"
          end-placeholder="年/月/日" :clearable="true" style="width: 280px" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" @change="getTime" />
      </el-form-item>
      <el-form-item :prop="item.id" :label="item.text" v-if="item.type === 'timeOrder'" style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" type="daterange" range-separator="-" start-placeholder="年/月/日"
          end-placeholder="年/月/日" :clearable="true" style="width: 280px" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" @change="getTimeOrder" />
      </el-form-item>
      <el-form-item :prop="item.id" :label="item.text" v-if="item.type === 'useTime'" style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" type="daterange" range-separator="-" start-placeholder="年/月/日"
          end-placeholder="年/月/日" :clearable="true" style="width: 280px" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" @change="getUseTime" />
      </el-form-item>
      <el-form-item :prop="item.id" :label="item.text" v-if="item.type === 'getTime'" style="width: 350px">
        <el-date-picker v-model="searchForm[item.id]" type="daterange" range-separator="-" start-placeholder="年/月/日"
          end-placeholder="年/月/日" :clearable="true" style="width: 280px" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" @change="getGetTime" />
      </el-form-item>
      <el-form-item :prop="item.id" :label="item.text" v-if="item.type === 'selectType'"
        style="width: 450px; margin-left: 10px">
        <el-radio-group style="margin-left: 10px" v-model="searchForm.orderType" @input="selectType">
          <el-radio :label="''">全部</el-radio>
          <el-radio :label="1">特惠单</el-radio>
          <el-radio :label="3">秒出单</el-radio>
        </el-radio-group>
      </el-form-item>
    </div>
    <el-form-item>
      <!-- 操作按钮 -->
      <el-button type="warning" @click="onFormSearch" :loading="$parent.searchForm.Loading">查询</el-button>
      <el-button type="warning" plain @click="onFormReset">重置</el-button>
      <el-button v-if="!hiddenExport" @click="onFormExport">导出数据</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { matchMobile, matchInteger } from "@/utils/regExp";
import debounce from '@/utils/debounce.js'
export default {
  name: "Index",
  props: [
    "searchList",
    "searchForm",
    "optionsType",
    "optionsStatus",
    "promoteList",
    "isRenewOption",
    "isAccount",
    "hiddenExport",
    "optionsTypeCoupon"
  ],
  data() {
    return {
      options: [
        {
          label: "1",
          value: "1",
        },
      ],
      haveExport: true,
    };
  },
  mounted() {
    if (this.isAccount === 1) {
      this.haveExport = false;
    }
  },
  methods: {
    // 搜索
    onFormSearch() {
      // 验证订单号
      debounce(() => {
        if (
          this.$parent.searchForm.orderId &&
          this.$parent.searchForm.orderId.length
        ) {
          if (!matchInteger.test(this.$parent.searchForm.orderId)) {
            this.$message.error("请输入正确的订单号");
            return;
          }
        }

        // 验证用户ID
        if (this.$parent.searchForm.id && this.$parent.searchForm.id.length) {

          if (!matchInteger.test(this.$parent.searchForm.id)) {
            this.$message.error("请输入正确的用户ID");
            return;
          }
        }

        // 验证推荐人ID
        if (
          this.$parent.searchForm.parentId &&
          this.$parent.searchForm.parentId.length
        ) {
          if (!matchInteger.test(this.$parent.searchForm.parentId)) {
            this.$message.error("请输入正确的推荐人ID");
            return;
          }
        }
        // 验证交易订单号
        if (
          this.$parent.searchForm.withdrawNo &&
          this.$parent.searchForm.withdrawNo.length
        ) {
          if (!matchInteger.test(this.$parent.searchForm.withdrawNo)) {
            this.$message.error("请输入正确的交易订单号");
            return;
          }
        }



        // 验证手机号
        if (
          this.$parent.searchForm.reservedPhone &&
          this.$parent.searchForm.reservedPhone.length
        ) {
          if (!matchMobile.test(this.$parent.searchForm.reservedPhone)) {
            this.$message.error("请输入正确的手机号码");
            return;
          }
        }


        if (this.$parent.searchForm) {
          this.$parent.searchForm.pageNo = 1;
        }
        this.$parent.getList("reload");
      }, 500, true)

    },
    // 重置
    onFormReset() {
      debounce(() => {
        this.$refs['searchForm'].resetFields();
        this.$parent.searchForm.startCreateTime = "";
        this.$parent.searchForm.endCreateTime = "";
        this.$parent.searchForm.orderCreateEndTime = "";
        this.$parent.searchForm.orderCreateStartTime = "";
        this.$parent.searchForm.orderType = "";
        this.$parent.getList("reset");
      }, 500, true)

    },
    getTime(e) {
      console.log(e);
      const status = e && e.length === 2;
      this.$parent.searchForm.startCreateTime = status ? e[0] : "";
      this.$parent.searchForm.endCreateTime = status ? e[1] : "";
    },
    getTimeOrder(e) {
      console.log(e);
      const status = e && e.length === 2;
      this.$parent.searchForm.orderCreateStartTime = status ? e[0] : "";
      this.$parent.searchForm.orderCreateEndTime = status ? e[1] : "";
    },
    getUseTime(e) {
      console.log(e);
      const status = e && e.length === 2;
      this.$parent.searchForm.useTimeStart = status ? e[0] : "";
      this.$parent.searchForm.useTimeEnd = status ? e[1] : "";
    },
    getGetTime(e) {
      console.log(e);
      const status = e && e.length === 2;
      this.$parent.searchForm.getTimeStart = status ? e[0] : "";
      this.$parent.searchForm.getTimeEnd = status ? e[1] : "";
    },
    // 导出
    onFormExport() {
      this.$parent.exportButton();
    },
    // 筛选订单
    selectType(e) {
      this.$parent.searchForm.orderType = e;
      this.$parent.getList();
    },
  },
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/components/Search/index.vue